import styled, { css } from "styled-components";
import {
    type WidthProps,
    type ZIndexProps,
    type PositionProps,
    type SpaceProps,
    width,
    zIndex,
    space,
} from "styled-system";

export const Wrapper = styled.div<
    PositionProps &
        WidthProps &
        ZIndexProps &
        SpaceProps & {
            ignoreNavOffset?: boolean;
            disableSticky?: boolean;
            top?: number;
        }
>`
    ${({ top, ignoreNavOffset }) => css`
        top: calc(${ignoreNavOffset ? "0px" : "var(--visibleHeaderHeight)"} + ${top}px);
    `};

    ${({ disableSticky }) => !disableSticky && "position: sticky;"}
    ${width};
    ${zIndex};
    ${space};
    transition: top 0.5s ease-out;
`;

export default Wrapper;
